import React from 'react';
import { connect } from 'react-redux';

import { startUpdateFunnel } from '../../../actions/funnel';
import CompoundSideListAddButton from '../../../components/compound/side/ListAddButton';
import { getMyPermissions } from '../../../reducers/analyticsApp';
import { staticPermissions } from '../../../constants/authorization';

const FunnelSideListAddButton = ({ tenantId, ...rest }) => (
  <CompoundSideListAddButton {...rest} path={`/${tenantId}/funnels/add`} title="Add Funnel" />
);

const mapStateToProps = (state, { tenantId }) => ({
  hasPermission: getMyPermissions(state).has(staticPermissions.FUNNEL_MANAGE),
  tenantId,
});

const mapDispatchToProps = {
  onAdd: startUpdateFunnel,
};

export default connect(mapStateToProps, mapDispatchToProps)(FunnelSideListAddButton);
